import styled, { css, keyframes } from 'styled-components'
import { media } from '../GlobalStyle'

type TimelineItemsProps = {
  first?: boolean
  last?: boolean
  left?: number
}

type TimelineDotsProps = {
  active?: number
}

const heartbeat = keyframes`
  from {
    transform: scale(1);
    transform-origin: center center;
    animation-timing-function: ease-out;
  }
  10% {
    transform: scale(0.91);
    animation-timing-function: ease-in;
  }
  17% {
    transform: scale(0.98);
    animation-timing-function: ease-out;
  }
  33% {
    transform: scale(0.87);
    animation-timing-function: ease-in;
  }
  45% {
    transform: scale(1);
    animation-timing-function: ease-out;
  }
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: center;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  position: relative;
  max-width: 100%;
  padding: 18px;

  ${media.small} {
    flex-direction: row;
  }
`

export const TimelineItems = styled.div<TimelineItemsProps>`
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: flex-start;
  position: relative;
  flex: 0 0 auto;

  ${media.small} {
    flex-direction: row;
  }
`

export const TimelineLine = styled.div`
  height: 0.15rem;
  background-color: ${(props) => props.theme.success};
  width: 80px;
  margin: -25px 0 3px 5px;
  width: 0.15rem;
  height: 30px;

  ${media.small} {
    height: 0.15rem;
    width: 80px;
    min-width: 20px;
    margin: 6px 5px 0 -8px;
  }
`

export const TimelineDots = styled.div<TimelineDotsProps>`
  border-radius: 100%;
  height: 12px;
  width: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  background-color: ${(props) =>
    props.active ? props.theme.success : '#cfe2ff'};

  animation: ${({ active }) =>
    active
      ? css`
          ${heartbeat} 1.5s ease-in-out infinite both
        `
      : 'none'};

  &::before {
    content: '';
    background-color: transparent;
    border: 3px solid
      ${(props) => (props.active ? props.theme.success : '#cfe2ff')};
    /* display: ${(props) => (props.active ? 'inline-block' : 'none')}; */
    display: inline-block;
    height: 24px;
    width: 24px;
    min-width: 24px;
    border-radius: 100%;
    opacity: 0.5;
    box-sizing: border-box;
  }
`

export const TimelineDescription = styled.div`
  line-height: 1.2;
  padding: 6px;
  padding-top: 0;
  text-align: left;

  p {
    font-size: 0.85em;
    margin: 0 0;
  }
  span {
    font-size: 0.65em;
    margin: 0 0;
    color: #828e97;
  }
`

export const TimelineErrorContainer = styled.div`
  padding: 12px;
  text-align: center;
  font-size: 1em;
  color: #828e97;
`
